import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { TextField, SelectField } from '../../fields';
import messages from '../../../text/messages';
import options from '../../../text/selectOptions';
import { required, number, maxValue } from '../../../utilities/validation';
import WizardButtons from '../../wizard/navigator/buttons';
import { FormattedMessage } from 'react-intl';
import { createFee, updateFee, deleteFee, getClientFees } from '../../../reducers/clients';

class FeeForm extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.getFormFields = this.getFormFields.bind(this);
        this.getSubmitMessage = this.getSubmitMessage.bind(this);
    }

    submit(values) {
        const { action, cancel, client, getClientFees, createFee, updateFee, deleteFee } = this.props;
        const postAction = () => {
            cancel();
            getClientFees(client.id);
        };

        switch (action) {
            case 'create':
                createFee(values, postAction);
                return;

            case 'update':
                updateFee(values, postAction);
                return;

            case 'delete':
                deleteFee(values, postAction);
                return;

            default:
                cancel();
                return;
        }
    }

    getFormFields() {
        const { action, readOnly } = this.props;
        if (action === 'delete') {
            return (
                <div className="text-center">
                    <FormattedMessage {...messages.confirmation} />
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-sm-3 col-xs-12">
                    <Field name={'country'} component={TextField} placeholder={messages.country} disabled={true} validate={required} />
                </div>
                <div className="col-sm-3 col-xs-12">
                    <Field name={'rate_currency'} component={TextField} placeholder={messages.currency} disabled={true} validate={required} />
                </div>
                <div className="col-sm-6 col-xs-12">
                    <Field name={'location_group_id'} component={TextField} placeholder={messages.locationGroup} disabled={readOnly === true} />
                </div>

                <div className="col-sm-3 col-xs-12">
                    <Field
                        name={'classify_result'}
                        component={SelectField}
                        options={options.workerClassification}
                        placeholder={messages.classification}
                        disabled={readOnly === true}
                    />
                </div>
                <div className="col-sm-3 col-xs-12">
                    <Field name={'time_type'} component={TextField} placeholder={messages.timeType} disabled={readOnly === true} />
                </div>
                <div className="col-sm-3 col-xs-12">
                    <Field
                        name={'rate_equal_or_above'}
                        component={TextField}
                        placeholder={messages.rateThreshold}
                        // The rate threshold feature is no longer supported,
                        // because of complexity arising from multiple rates per job.
                        // Currently one fee rule is selected and the worker pay is multiplied by the fee rate of the rule.
                        // Since a job can now have multiple rates, this needs to be enhanced so that the portion of the
                        // worker pay at each pay rate is multiplied by the fee percentage for that pay rate.
                        //
                        // Since that's not implemented, for now we force the pay rate threshold to 0.
                        // That way every pay rate for the job will have the same fee and the calculation will be correct.
                        // disabled={readOnly === true}
                        disabled={true}
                        validate={required}
                    />
                </div>
                <div className="col-sm-3 col-xs-12">
                    <Field
                        name={'fee'}
                        component={TextField}
                        placeholder={messages.fee}
                        disabled={readOnly === true}
                        validate={[required, number, maxValue(99)]}
                        extras={{ right: '%' }}
                    />
                </div>

                <div className="col-sm-3 col-xs-12">
                    <Field name={'priority'} component={TextField} placeholder={messages.weight} disabled={readOnly === true} validate={required} />
                </div>
            </div>
        );
    }

    getSubmitMessage() {
        const { action } = this.props;

        let message;
        switch (action) {
            case 'create':
                message = messages.create;
                break;

            case 'update':
                message = messages.update;
                break;

            case 'delete':
                message = messages.delete;
                break;

            default:
                message = messages.submit;
                break;
        }

        return <FormattedMessage {...message} />;
    }

    render() {
        const { handleSubmit, cancel, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                {this.getFormFields()}
                <WizardButtons disabled={submitting} cancel={{ action: cancel }} submit={{ message: this.getSubmitMessage() }} />
            </form>
        );
    }
}

FeeForm = reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(FeeForm);

const mapStateToProps = (state, props) => {
    const fee = props.fee || {};
    const { client } = props;
    return {
        form: `fee-form-${fee && fee.id ? fee.id : 'new'}`,
        initialValues: {
            ...fee,
            country: fee.country || 'US',
            rate_currency: fee.rate_currency || 'USD',
            client_id: fee.client_id || client.id,
            rate_equal_or_above: 0
        }
    };
};
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientFees,
            createFee,
            updateFee,
            deleteFee
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FeeForm);



// WEBPACK FOOTER //
// ./src/components/forms/fee/index.jsx